<div class="ks-loader" [class.is-inline]="size === 'inline'" role="status" [attr.aria-live]="'polite'">
  <img class="ks-loader-mark" src="/assets/logo/logo-loader.gif" alt="" aria-hidden="true" />
  <span class="ks-loader-label">{{ label }}</span>
</div>
